import { Box, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { getSharedSentTimeline } from 'api/teams'
import { useAuthContext } from 'components/context/AuthProvider'
import FailPlaceholder from 'components/placeholders/FailPlaceholder'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import { useTeams } from 'features/Timeline/hooks/useTeams'
import { useQuery } from 'react-query'
import { SharedSentTable } from '../SharedSentTable/SharedSentTable'

export function SharedSentTab() {
  const theme = useTheme()
  const matchesXs = useMediaQuery(theme.breakpoints.down('sm'))
  const { user } = useAuthContext()
  const userId = user?.id
  const { activeTeamId } = useTeams()

  const sharedQuery = useQuery(
    ['getSharedSent', userId],
    () => {
      if (activeTeamId === null || !userId) return
      return getSharedSentTimeline({ userId, teamId: activeTeamId })
    },
    {
      enabled: activeTeamId !== null && userId !== undefined,
    },
  )

  const failPlaceholder = (
    <Box mt={2}>
      <FailPlaceholder error="No data has been shared by the user" />
    </Box>
  )

  if (sharedQuery.isFetching) {
    return <LoadingPlaceholder />
  }

  if (sharedQuery.data && sharedQuery.data.data.length === 0 && sharedQuery.isSuccess) {
    return failPlaceholder
  }

  if (!sharedQuery.data) {
    return failPlaceholder
  }

  return (
    <Box mt={2} pl={matchesXs ? 1 : 0} pr={1} mb={matchesXs ? 0 : '80px'}>
      <SharedSentTable data={sharedQuery.data.data} />
    </Box>
  )
}
